import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { TabContext, TabList } from "@mui/lab";

import AssignmentList from "./AssignmentList";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
const AssignmentTabs = (props) => {
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const [total, setTotal] = useState(0);
  const [numberAssignments, setNumberAssignments] = useState(0);

  const handleChange = (event, newValue) => {
    setTotal(0);
    setNumberAssignments(0);
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            aria-label="lab API tabs example"
            centered
          >
            <Tab
              label={value == 0 ? `New (${numberAssignments}/${total})` : `New`}
              {...a11yProps(0)}
              sx={{ px: 8, textTransform: "inherit", fontWeight: '600', color: '#5f5600ff', fontSize: '1rem','@media (min-width: 1636px)': {fontSize: '1.4rem'} }}
            />
            <Tab
              label={value == 1 ? `Pending (${numberAssignments}/${total})` : `Pending`}
              {...a11yProps(1)}
              sx={{ px: 8, textTransform: "inherit", fontWeight: '600', color: '#5f5600ff', fontSize: '1rem','@media (min-width: 1636px)': {fontSize: '1.4rem'} }}
            />
            <Tab
              label={value == 2 ? `Completed (${numberAssignments}/${total})` : `Completed`}
              {...a11yProps(2)}
              sx={{  px: 8,textTransform: "inherit", fontWeight: '600', color: '#5f5600ff', fontSize: '1rem','@media (min-width: 1636px)': {fontSize: '1.4rem'} }}
            />
            <Tab
              label={value == 3 ? `Expired (${numberAssignments}/${total})` : `Expired`}
              {...a11yProps(3)}
             sx={{  px: 8,textTransform: "inherit", fontWeight: '600', color: '#5f5600ff', fontSize: '1rem','@media (min-width: 1636px)': {fontSize: '1.4rem'} }}
            />
          </TabList>
        </Box>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <AssignmentList filter="new" setTotalNumber={(t)=>{setTotal(t)}} setAssignmentNumber={(a)=>{setNumberAssignments(a)}}></AssignmentList>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <AssignmentList filter="pending" setTotalNumber={(t)=>{setTotal(t)}} setAssignmentNumber={(a)=>{setNumberAssignments(a)}}></AssignmentList>
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <AssignmentList filter="finished" setTotalNumber={(t)=>{setTotal(t)}} setAssignmentNumber={(a)=>{setNumberAssignments(a)}}></AssignmentList>
        </TabPanel>
        <TabPanel value={value} index={3} dir={theme.direction}>
          <AssignmentList filter="expired" setTotalNumber={(t)=>{setTotal(t)}} setAssignmentNumber={(a)=>{setNumberAssignments(a)}}></AssignmentList>
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default AssignmentTabs;
